<template>
    <v-dialog :value="show" persistent max-width="400" no-click-animation>
        <v-card class="rounded-card" style="background-color: white !important">
            <v-card-text class="title">
                <span class="title font-weight-bold">{{ message ? $t(message) : $t('Please stand by') }}...</span>
                <v-progress-linear indeterminate :query="lang !== 'en'" color="#292F7D" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'LoadingDialog',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: ''
        }
    },
    computed: {
        lang() {
            return this.$store.state.Global.lang;
        }
    }
});
</script>

<style scoped>
    .title{
        font-family: 'Open Sans', 'Arial', monospace !important;
    }
</style>